module.exports = __webpack_public_path__ + "templates.dialog.merchant-tiers-96c68033.html";